"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDefaultMarker = void 0;
var _markerPinDefault = _interopRequireDefault(require("../resource/marker-pin-default.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// expects a HereMarkerInit config object
// returns an H.map.Marker object or null if successful
var createDefaultMarker = function createDefaultMarker(markerConfig) {
  if (markerConfig.options && markerConfig.options.icon) {
    var size = markerConfig.options.icon.size ? markerConfig.options.icon.size : {
      w: 16,
      h: 16
    };
    var iconElement;
    var iconConfig = markerConfig.options.icon;
    if (iconConfig) {
      // if we were given an element for the icon...
      if (iconConfig.element) {
        iconElement = iconConfig.element();
      }
      // else we need to create our own element for the icon
      else {
        iconElement = document.createElement('img');
        iconElement.crossOrigin = markerConfig.options.icon.crossOrigin ? markerConfig.options.icon.crossOrigin : "anonymous";
        iconElement.width = size.w;
        iconElement.height = size.h;

        // if we were given a src value...
        if (iconConfig.iconSrc) {
          iconElement.src = iconConfig.iconSrc;
        }
        // else we will use the default src value
        else iconElement.src = _markerPinDefault.default;
      }
      if (iconElement) {
        var icon = new H.map.Icon(iconElement, {
          crossOrigin: markerConfig.options.icon.crossOrigin ? true : false,
          size: size
        });
        var newMarker = new H.map.Marker(markerConfig.position, {
          icon: icon
        });
        return newMarker;
      }
    }
  }
  return null;
};
exports.createDefaultMarker = createDefaultMarker;